import { postUpdateGive } from '../api/postUpdateGive';

const setPostUpdateGive = (params) => {
    return async (dispatch, getState) => {
        try {
            await postUpdateGive(params);     
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setPostUpdateGive
}